import App from './App'
import store from './store'
import router from './router'
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

const customRootObject ={ //退出登录后不会被重置
    eventBus:new Vue(),
}
const rootObject ={  //退出登录后被重置

}
console.log(router)
window.vm=new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: { App },
    data(){
        return {
            ...customRootObject,
            ...rootObject
        }
    }
})
window.vm.$root.resetCustomRootObject=function(){ //重置rootObject
    Object.keys(rootObject).forEach(key=>{
        window.vm.$root[key] = rootObject[key]
    })

}
